import * as z from "zod";

export const CoverageQaSettings = z.object({ enabled: z.boolean() });
export type CoverageQaSettings = z.infer<typeof CoverageQaSettings>;
